import React, { useEffect, useState } from 'react';
import { DataTableColumn } from '@common/components/datatable/types';
import Badge from '@common/components/badge';
import Icon from '@common/components/icon';
import Tooltip from '@common/components/tooltip';
import Dropdown from '@common/components/dropdown';
import ConfirmButton from '@common/components/confirm-button';
import BadgeCount from '@common/components/badgeCount';
import { Trans, useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router';
import LinkWrapper from '@common/components/linkWrapper';
import Profile from '@common/components/profile';

export default (columnOptions: any) => {
  const { t } = useTranslation();
  const history = useHistory();
  const params = useParams<{ networkId: string }>();
  const basePath = params.networkId ? `/networks/${params.networkId}` : '/admin';
  const [columns, setColumns] = useState<DataTableColumn[]>([]);

  const { handleDeleteCompetancy } = columnOptions;

  useEffect(() => {
    const baseColumns: DataTableColumn[] = [
      {
        key: 'name',
        label: t('performance:competencies'),
        options: {
          size: 200,
          render: (row: any) => {
            return (
              <div className="tw-flex tw-flex-row tw-gap-2 tw-items-center tw-justify-between">
                <a
                  className="tw-font-medium tw-text-base tw-text-gray-textDarkest"
                  onClick={() => {
                    const base = `${basePath}/performance/competency-library/${row.id}/edit`;
                    return history.push(`${base}`);
                  }}
                >
                  {row.name}
                </a>
                {row.description && (
                  <Tooltip title={row.description}>
                    <Icon
                      type="info"
                      className="tw-text-gray-textGray !tw-h-4 !tw-w-4"
                    />
                  </Tooltip>
                )}
              </div>
            );
          },
        },
      },
      {
        key: 'functions',
        label: t('performance:functions'),
        options: {
          size: 250,
          render: (row: any) => {
            return (
              <div className="tw-flex tw-flex-wrap tw-gap-1">
                {row.functions && row.functions.length > 0 ? (
                  <div className="tw-flex tw-flex-wrap tw-gap-1">
                    {row.functions.slice(0, 3).map((func: any) => (
                      <Badge key={func.id || func.name} text={func.name} />
                    ))}
                    {row.functions.length > 3 && (
                      <BadgeCount
                        title={row.functions.map((func: any) => (
                          <div>{func.name}</div>
                        ))}
                        count={row.functions.length - 3}
                      />
                    )}
                  </div>
                ) : (
                  <small>
                    <Trans i18nKey="organisation:users_email_empty" />
                  </small>
                )}
              </div>
            );
          },
        },
      },
      {
        key: 'created_by',
        label: t('performance:created_by'),
        options: {
          size: 200,
          render: (row: any) => {
            return (
              <LinkWrapper
                url={`${basePath}/users/${row.created_by.id}/about`}
                className="tw-text-inherit hover:tw-text-inherit hover:tw-underline"
              >
                <Profile enablePopover size={30} user={row.created_by} />
              </LinkWrapper>
            );
          },
        },
      },
      {
        key: 'actions',
        label: '',
        className: 'Table__Action',
        options: {
          size: 20,
          render: (row: any) => {
            return (
              <Dropdown
                className="MembershipRowDropdown"
                alignRight
                trigger={
                  <Icon
                    type="three_dot_horiz"
                    size={18}
                    className="tw-text-gray-muted"
                  />
                }
              >
                <Dropdown.Item
                  icon="edit__filled"
                  onClick={() => {
                    const base = `${basePath}/performance/competency-library/${row.id}/edit`;
                    return history.push(`${base}`);
                  }}
                >
                  {t('performance:edit_competency')}
                </Dropdown.Item>
                <ConfirmButton
                  danger
                  title={t('performance:delete_competency')}
                  description={t('performance:delete_competency_description')}
                  onConfirm={() => handleDeleteCompetancy(row)}
                  confirmText={t('performance:delete_competency')}
                >
                  <Dropdown.Item icon="delete__filled">
                    {t('performance:delete_competency')}
                  </Dropdown.Item>
                </ConfirmButton>
              </Dropdown>
            );
          },
        },
      },
    ];
    setColumns(baseColumns);
  }, [t, basePath]);

  return columns;
};
